
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/orgs",
      function () {
        return require("private-next-pages/orgs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/orgs"])
      });
    }
  